module.exports = __webpack_public_path__ + "static/media/Close.87697518.svg";